export default __webpack_public_path__ + "static/media/home2.c3d6da0a.png";